export default __webpack_public_path__ + "static/media/bxl-react.07774d3d.svg";